(() => {
  const initializeRitualOffers = (scope = document) => {
    scope.querySelectorAll('[data-ho-oct-root]').forEach((root) => {
      if (root.dataset.initialized === 'true' || root.dataset.themeInitialized === 'true') return;
      root.dataset.initialized = 'true';
      root.dataset.themeInitialized = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-ho-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-ho-panel]'));
      const countdown = root.querySelector('[data-ho-countdown]');
      const closed = root.querySelector('[data-ho-closed]');
      const deadline = new Date(root.dataset.deadline).getTime();

      const activateTab = (name, moveFocus = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.hoTab === name;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus) tab.focus();
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.hoPanel !== name;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab.dataset.hoTab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          activateTab(tabs[nextIndex].dataset.hoTab, true);
        });
      });

      const format = (value) => String(value).padStart(2, '0');

      const updateCountdown = () => {
        const remaining = deadline - Date.now();

        if (!Number.isFinite(deadline) || remaining <= 0) {
          if (countdown) countdown.hidden = true;
          if (closed) closed.hidden = false;
          return false;
        }

        const values = {
          days: Math.floor(remaining / 86400000),
          hours: Math.floor((remaining % 86400000) / 3600000),
          minutes: Math.floor((remaining % 3600000) / 60000),
          seconds: Math.floor((remaining % 60000) / 1000)
        };

        const targets = {
          days: root.querySelector('[data-ho-days]'),
          hours: root.querySelector('[data-ho-hours]'),
          minutes: root.querySelector('[data-ho-minutes]'),
          seconds: root.querySelector('[data-ho-seconds]')
        };

        Object.entries(values).forEach(([key, value]) => {
          if (targets[key]) targets[key].textContent = format(value);
        });
        return true;
      };

      if (updateCountdown()) {
        const timer = window.setInterval(() => {
          if (!document.documentElement.contains(root) || !updateCountdown()) {
            window.clearInterval(timer);
          }
        }, 1000);
      }
    });
  };

  initializeRitualOffers();
  document.addEventListener('shopify:section:load', (event) => initializeRitualOffers(event.target));
})();
